module.exports = __webpack_public_path__ + "static/media/teacher19.9e15e6cd.png";